

export default function inlineSVG(selector) {

    $(selector).each(function(){
        const $img = $(this);
        const element = $img.get(0);

        if (element.nodeName.toLowerCase() === 'img') {

            const img_id = $img.attr('id');
            const img_class = $img.attr('class');
            const img_src = $img.attr('src');

            $.get(img_src, function(data){

                const $svg = $(data).find('svg');

                if (typeof img_id !== 'undefined') $svg.attr('id', img_id);
                if (typeof img_class !== 'undefined') $svg.attr('class', img_class);

                $svg.removeAttr('xmlns:a');

                if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
                }

                $img.replaceWith($svg);

            }, 'xml');
        }
    });
}